import React, { Component } from 'react';
import Waypoint from 'react-waypoint';
import ReactMarkdown from 'react-markdown';
import { prepareMarkDown } from '../helpers/helpers.js';
import Line from '../charts/line.js';
import './keywords.css';
import Texts from '../data/keywords.json';
 
class Keywords extends Component {
	constructor(props) {
    super(props);
    this.waypointPositionChanged = this.waypointPositionChanged.bind( this );
    this.state = {
      step: -1,
      title: ''
    }
	}
	
	componentDidMount() {
  }

  componentDidUpdate( prevProps, prevState ) {}

  waypointPositionChanged( pos, step, title ) {
    if ( pos.currentPosition === 'inside' ) {
      this.setState( { step, title } );
    }
    if ( step === 0 && pos.currentPosition === 'below' ) {
      step = -1;
      this.setState( { step, title: '' } );
    }
    if ( step === 4 && pos.currentPosition === 'above' ) {
      step = -1;
      this.setState( { step, title: '' } );
    }
  }

	render() {
    let series = [];
    Texts.forEach(
      (item) => {
        series.push( this.props.Data.data.keywords[item.id] );
    });
    return (
      <div className="keywords in" data-step={this.state.step}>
        <div className="keywords--legend">
          <div className="keywords--legend--item item" >
            <div className="item--text">
              <div className="item--text--title">
                <h1>Le parole</h1>
              </div>
              <div className="item--text--body">
                <div>
                  <p>La questa campagna elettorale è stata molto incentrata sulle <em>parole</em> più che sui programmi. Quella che si è vista è stata una battaglia a colpi di slogan, e ben pochi tra noi elettori sono stati realmente in grado di capire in profondità le proposte delle diversi parti politiche.</p>
                  <h3>Le parole sono importanti?</h3>
                  <p>Sicuramente sì. Non siamo in grado di stabilire <strong>quanto</strong> le singole parole che hanno caratterizzato questa campagna abbiano influenzato il voto, quello che possiamo cercare di capire, tramite la copertura data dalla stampa, è se <strong>quelle</strong> parole sono state usate anche <strong>dopo</strong> le elezioni.</p>
                  <h3>Il metodo</h3>
                  <p>Tra i nostri oltre <strong>28.800</strong> articoli, abbiamo contato per ogni giorno quanti articoli contengono una parola (o un <em>set di parole</em>) per verificare quanto alcuni dei temi ritenuti <em>caldi</em> in campagna elettorale abbiano poi avuto seguito nell'immediato dopo elezioni.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <figure className="keywords--chart">
          <div className="in">
            <div className="keywords--chart--wrapper">
              <h3>{this.state.title}</h3>
              <Line series={ series } />
            </div>
          </div>
        </figure>
        <div className="keywords--data">
          {
            Texts.map(
              (item, index) => {
                return (
                  <Waypoint onPositionChange={ (position) => { this.waypointPositionChanged(position, index, item.title); } } topOffset="80%" bottomOffset="10%" key={item.id + index}>
                    <article  className="item">
                      <div className="item--text--title">
                        <h2>{item.title}</h2>
                      </div>
                      <div className="item--text--body">
                        <ReactMarkdown source={prepareMarkDown(item.body)} />
                        <div className="tags">
                          <ol>
                            <li className="intro">Keywords:</li>
                            {
                              item.terms.map(
                                (term,index) => {
                                return (<li key={term + index}><a key={term} href={"/#/filtra/" + escape(term)}><span>{term}</span></a></li> )
                                }
                              )
                            }
                          </ol>
                        </div>
                      </div>
                    </article>
                  </Waypoint>
                )
              }
            )
          }
        </div>
      </div>
    )
	}
}

export default Keywords;


// WEBPACK FOOTER //
// ./src/Elezioni/dataviz/keywords.js